import React from 'react';
import { Col } from 'reactstrap';
import { Link } from 'react-router-dom';

export function CampGettingStartedWidget() {
  return (
    <Col xs={12} sm={6} xl={4}>
      <div className='widget' id='CampGettingStartedWidget'>
        <h2>Getting Started</h2>
        <div style={{ padding: '0 16px 16px' }}>
        <p style={{ marginTop: '8px' }}>Welcome! To get your camp set up, complete these two steps:</p>
        <ol style={{ paddingLeft: '20px', marginTop: '8px' }}>
          <li style={{ marginBottom: '8px' }}>
            <strong><Link to='/bm/platoons'>Go to Bunks</Link></strong> and add your camp's bunks.
          </li>
          <li>
            <strong><Link to='/bm/soldiers'>Go to the Campers page</Link></strong> and click on the Upload Camper List button and follow the instructions there.
          </li>
        </ol>
        </div>
      </div>
    </Col>
  );
}



// WEBPACK FOOTER //
// ./src/pages/home/widgets/CampGettingStartedWidget.jsx